import { render, staticRenderFns } from "./AppConfirmDialog.vue?vue&type=template&id=65a4ac0b&scoped=true&"
import script from "./AppConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./AppConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppConfirmDialog.vue?vue&type=style&index=0&id=65a4ac0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a4ac0b",
  null
  
)

export default component.exports